import { Component, Input } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { Team } from '../../../shared/model';

@Component({
  selector: 'app-edit-team',
  templateUrl: './edit-team.component.html',
  styleUrls: ['../../../shared/styles/edit-modal.css', '../../../shared/styles/translation.css']
})
export class EditTeamComponent {

  @Input() team: Team;

  myForm: FormGroup;
  locationMissing = false;
  nameMissing = false;

  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder) {
    this.createForm();
  }

  createForm() {
    this.myForm = this.formBuilder.group({
      Id: '',
      Name: '',
      Location: ''
    });
  }

  setFormValues(team: Team) {
    this.myForm.patchValue(team);
  }

  submitForm() {
    this.activeModal.close(this.myForm.value);
  }

  verifyChanges() {
    this.checkName();
    this.checkLocation();

    if (!this.nameMissing && !this.locationMissing) {
      this.submitForm();
    }
  }

  checkLocation() {
    this.locationMissing = !(!!this.myForm.get('Location').value && this.myForm.get('Location').value.trim() !== '');
  }

  checkName() {
    this.nameMissing = !(!!this.myForm.get('Name').value && this.myForm.get('Name').value.trim() !== '');
  }
}
